import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className="site-header">
      <div className="page site-header__inner">
        <Link className="site-brand" to="/" aria-label="Escala de Glasgow — início">
          <span className="site-brand__mark" aria-hidden="true">
            <svg viewBox="0 0 36 36" width="24" height="24" fill="none" focusable="false">
              <circle cx="18" cy="18" r="15" stroke="currentColor" strokeWidth="2" />
              <path d="M24.5 12.5a9 9 0 1 0 1.2 9H18v-5h10v3.5a10 10 0 1 1-3.5-9.1" fill="currentColor" />
              <path d="M9 15h4m-4 6h4m10-6h4" stroke="var(--accent)" strokeWidth="1.7" strokeLinecap="round" />
            </svg>
          </span>
          <span>
            <strong>Escala de Glasgow</strong>
            <small>calculadora clínica</small>
          </span>
        </Link>

        <nav className="site-nav" aria-label="Navegação principal">
          <a href="/#calculadora">Calculadora</a>
          <Link to="/tabela">Tabela</Link>
          <Link to="/pediatrica">Pediátrica</Link>
          <Link to="/ecg-p">ECG-P</Link>
          <Link to="/como-avaliar">Como avaliar</Link>
          <Link to="/referencias">Referências</Link>
        </nav>

        <a
          className="site-header__ecosystem"
          href="https://eidoc.com.br/ferramentas"
          target="_blank"
          rel="noopener noreferrer"
        >
          Ei Doc · Ferramentas ↗
        </a>
      </div>
    </header>
  );
};

export default Header;
